

export default {
  props: {
    questions: {
      type: Array,
      required: true
    }
  },
  methods: {
    videoObject (video) {
      return {
        '@type': 'VideoObject',
        name: video.title,
        description: video.description,
        contentUrl: `https://www.youtube.com/watch?v=${video.videoId}`,
        embedUrl: `https://www.youtube.com/embed/${video.videoId}`,
        thumbnailUrl: `https://img.youtube.com/vi/${video.videoId}/sddefault.jpg`,
        uploadDate: video.publishedAt
      }
    }
  },
  computed: {
    questionsData () {
      return this.questions.map(question => ({
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.answer,
          video: question.video ? this.videoObject(question.video) : null
        }
      }))
    },
    jsonld () {
      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: this.questionsData
      }
    }
  }
}
